import { render, staticRenderFns } from "./Tabla.vue?vue&type=template&id=ae3a98ca&scoped=true&"
import script from "./Tabla.vue?vue&type=script&lang=ts&"
export * from "./Tabla.vue?vue&type=script&lang=ts&"
import style0 from "./Tabla.vue?vue&type=style&index=0&id=ae3a98ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae3a98ca",
  null
  
)

export default component.exports